import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { PageState } from '../../../../../../store/models/page.model';
import { setBannerComponent } from '../../../../../../store/actions/page.action';

@Component({
  selector: 'app-register-step-confirm',
  templateUrl: './register-step-confirm.component.html',
  styleUrls: ['./register-step-confirm.component.scss'],
})
export class RegisterStepConfirmComponent implements OnInit {
  @Input() confirmationToken: string;

  @Input() confirmationErrorMessage: string;

  @Output() Submit: EventEmitter<string> = new EventEmitter<string>();

  validationForm: FormGroup;

  submitForm = () => {
    this.Submit.emit(this.token.value);
  };

  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Confirm' }));
    this.validationForm = new FormGroup({
      token: new FormControl(this.confirmationToken || '', [
        Validators.required,
      ]),
    });
  }

  ngOnInit() {
    window.scroll(0, 0);
    if (this.confirmationToken) {
      this.token.setValue(this.confirmationToken);
      this.token.disable();
    }
  }

  get token() {
    return this.validationForm.get('token');
  }
}
